const url = 'https://jobsback.onrender.com'
//const url = 'http://localhost:8080'

export default url
